import type { ReactNode } from "react";

interface Props {
  label: string;
  htmlFor?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: ReactNode;
}

export default function FormField({ label, htmlFor, required, hint, error, children }: Props) {
  return (
    <div className="bo-field">
      <label htmlFor={htmlFor} className="bo-field__label">
        {label}
        {required && <span className="bo-field__required">*</span>}
      </label>
      {children}
      {error ? (
        <p className="bo-field__error">{error}</p>
      ) : hint ? (
        <p className="bo-field__hint">{hint}</p>
      ) : null}
    </div>
  );
}
